"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = useLocale;
const react_intl_1 = require("react-intl");
function useLocale() {
    const intl = (0, react_intl_1.useIntl)();
    return intl.locale;
}
//# sourceMappingURL=use-locale.js.map